import { ScreenAttributes } from 'core/flow/entities';
import { Images } from './Images';
import { HiddenWrapperStyled } from './styled';

type ImagesPreloaderProps = {
  attributes: ScreenAttributes[];
};

export const ImagesPreloader = ({ attributes }: ImagesPreloaderProps) => (
  <HiddenWrapperStyled>
    <Images attributes={attributes} />
  </HiddenWrapperStyled>
);
